import { usePage } from '@inertiajs/react';

import { activeCrumb } from '@/data/navigation';

// Context crumb derived from the current URL ("Comunicação · Mensagens").
// Rendered by AdminLayout above each page; hidden on routes outside the nav.
export function AdminBreadcrumb() {
  const { url } = usePage();
  const crumb = activeCrumb(url);
  if (!crumb) return null;

  return (
    <p className="text-on-surface-light/70 mb-2 text-xs font-medium">
      {crumb.group}
      <span className="px-1.5">·</span>
      {crumb.label}
    </p>
  );
}
